import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

import Gallery from "../../../../../components/gallery/gallery.js";

import faketradiing1 from "../../../../../../assets/fakeTradiing1.png";
import faketradiing2 from "../../../../../../assets/fakeTradiing2.png";

export default function FakeTradiing({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="FakeTradiing" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="fakeTradiingPanel">
            <Trans i18nKey="fakeTradiingDetails" />

            <a href="https://faketradiing.com/" target="_blank" className="text-center block mt-2">FakeTradiing</a>

            <h2 className="text-center titles text-800">{t("technologies")}</h2>

            <p className="text-center">ReactJs, Hibernate, Spring, Github, SonarQube, JUnit, REST api, JWT, AWS, Firebase authentification</p>

            <h2 className="text-center titles text-800">{t("pictures")}</h2>

            <Gallery images={[faketradiing1,faketradiing2]}/>
        </Dialog>
    )
}